export default {
      id: "circle-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#circle",
      toString: function () {
        return this.url;
      }
    }